import http from '@utils/http-common';
import APIRoute from '@constants/routes';

class InfosService {
    viewInfo(infoIds: string[]) {
        return http.post<any, any>(APIRoute.INFOS_VIEW, { infos_id: infoIds });
    }
}
export default new InfosService();
